import { Sortable } from 'sortablejs';
import ApplicationController from '../editor/application_controller';
import { createRequest } from '../helpers/createRequest';
import { htmlToElement } from '../helpers/dom';
// import { createRequest } from '../helpers/createRequest';

export default class extends ApplicationController {
  connect() {
    const groups = document.querySelectorAll('.users');
    console.log(groups);
    groups.forEach((group) => {
      Sortable.create(group, {
        animation: 150,
        group: 'users',
        filter: 'input',
        preventOnFilter: true,
        onEnd: (evt) => {
          const groupId = evt.to.dataset.groupId || '';
          const { userId } = evt.item.dataset;
          console.log(groupId, userId);
          const formData = new FormData();
          formData.append('group_id', groupId);
          formData.append('user_id', userId);
          fetch(createRequest(`/x1/studios/${studioId}/groups/members`, 'PATCH', formData))
            .then((response) => response.text())
            .then((html) => {
              console.log(html);
            });
        },
      });
    });
  }

  createGroup(event) {
    console.log(event);
    const { studioId } = event.target.dataset;
    fetch(createRequest(`/x1/studios/${studioId}/groups`, 'POST'))
      .then((response) => response.text())
      .then((html) => {
        const groups = document.querySelector('.groups');
        groups.appendChild(htmlToElement(html));
        this.connect();
      });
  }

  deleteGroup(event) {
    const { groupId, studioId } = event.currentTarget.dataset;
    // Capture the group element before the async operation
    const groupElement = event.currentTarget.closest('.p-2.rounded.shadow-sm');
    
    if (confirm('Are you sure you want to delete this group?')) {
      fetch(createRequest(`/x1/studios/${studioId}/groups/${groupId}`, 'DELETE'))
        .then((response) => {
          if (response.ok) {
            // Remove the group element from the DOM
            if (groupElement) {
              groupElement.remove();
            }
          } else {
            alert('Failed to delete group');
          }
        })
        .catch((error) => {
          console.error('Error deleting group:', error);
          alert('Error deleting group');
        });
    }
  }

  addGroupFormation(event) {
    console.log(event.target.dataset);
    const formData = new FormData();
    formData.append('section_id', event.target.dataset.tabId);
    fetch(createRequest(`/x1/studios/${event.target.dataset.studioId}/groups/formation`, 'PATCH', formData))
      .then((response) => response.text())
      .then((html) => {
        console.log(html);
      });
    window.location.reload();
  }

  removeGroupFormation(event) {
    const formData = new FormData();
    formData.append('section_id', null);
    fetch(createRequest(`/x1/studios/${event.target.dataset.studioId}/groups/formation`, 'PATCH', formData))
      .then((response) => response.text())
      .then((html) => {
        console.log(html);
      });
    window.location.reload();
  }

  async createTeamsForStage(event) {
    event.preventDefault();
    const { studioId, tabId } = event.target.dataset;
    
    try {
      // Set the group formation for this stage
      const formData = new FormData();
      formData.append('section_id', tabId);
      
      const response = await fetch(createRequest(`/x1/studios/${studioId}/groups/formation`, 'PATCH', formData));
      
      if (response.ok) {
        // Reload the page - server-side template will render the Teams link
        window.location.reload();
      }
    } catch (error) {
      console.error('Error creating teams:', error);
    }
  }
}
